export default __webpack_public_path__ + "static/media/icon1.30561356.svg";